/* TypeScript file generated from CatPaintingsPage.res by genType. */

/* eslint-disable */
/* tslint:disable */

import * as CatPaintingsPageJS from './CatPaintingsPage.re.mjs';

export type props = {};

export const make: React.ComponentType<{}> = CatPaintingsPageJS.make as any;

export const $$default: React.ComponentType<{}> = CatPaintingsPageJS.default as any;

export default $$default;
